
































import { Component, Vue, Watch } from "vue-property-decorator";
import { HttpService } from "@/services/api/httpService";
import { QuestionValue } from "@/types/questionValue";
import { SaveMixin } from "@/services/mixins/saveMixin";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
@Component({
  mixins: [SaveMixin],
  validations: {
    questionValue: {
      name: { required, maxLength: maxLength(300) },
      sortOrder: { required, numeric }
    }
  }
})
export default class QuestionValueEdit extends Vue {
  questionValue: QuestionValue = new QuestionValue();
  questionValueId: number = 0;
  questionId: string = "";
  backRoute = {
    name: "questionsEdit",
    params: { id: "" }
  };

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.questionId = this.$route.params.id;
    this.questionValueId = Number(this.$route.params.id2);
    this.backRoute.params.id = this.questionId;
    this.getValue();
  }

  async getValue() {
    let httpService = new HttpService<QuestionValue>();
    await httpService
      .getItem(`questions/${this.questionId}/values/${this.questionValueId}`)
      .then(response => {
        this.questionValue = response.data || new QuestionValue();
      });
  }

  async save() {
    let httpService = new HttpService<QuestionValue>();
    this.$store.commit("SAVE", false);
    this.$v.$touch();
    if (!this.$v.$invalid) {
      await httpService
        .putItem(
          `quesitons/${this.questionId}/values/${this.questionValueId}`,
          this.questionValue
        )
        .then(response => {
          this.$router.push(this.backRoute);
          this.$notification.success("Question answer successfully updated!");
          this.$store.dispatch("SET_DIRTY", false);
        });
    }
  }
}
